import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { UserFeedbackLinkBlockConfig } from '@front-platform/content-builder';
import { userFeedbackLinkBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input, computed } from '@angular/core';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
import { OrderStoreSelector } from '@common/selectors/order.selector';

enum ExternalLinkButtonType {
  text = 'text',
  light = 'light',
  normal = 'normal',
  outlined = 'outlined',
}

type ExternalLinkButtonTarget = '_blank' | '_self';
export interface UserFeedbackLinkBlockRuntimeConfig {}

export type UserFeedbackLinkBlockConfigInput = Partial<
  Omit<UserFeedbackLinkBlockConfig, keyof UserFeedbackLinkBlockRuntimeConfig> &
    UserFeedbackLinkBlockRuntimeConfig
>;
export type UserFeedbackLinkBlockResolvedConfig = Omit<
  UserFeedbackLinkBlockConfig,
  keyof UserFeedbackLinkBlockRuntimeConfig
> &
  Partial<UserFeedbackLinkBlockRuntimeConfig>;
export interface UserFeedbackLinkBlockContract extends ConfigComponentContract<
  UserFeedbackLinkBlockConfigInput,
  UserFeedbackLinkBlockResolvedConfig
> {}

@Component({
  selector: 'app-user-feedback-link-block',
  templateUrl: './user-feedback-link-block.component.html',
  styleUrls: ['./user-feedback-link-block.component.scss'],
  standalone: false,
})
export class UserFeedbackLinkBlockComponent implements UserFeedbackLinkBlockContract {
  readonly config = input<UserFeedbackLinkBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    UserFeedbackLinkBlockConfig,
    UserFeedbackLinkBlockRuntimeConfig
  >(userFeedbackLinkBlockResolveConfig, () => ({ config: this.config() }));

  constructor(private readonly orderSelector: OrderStoreSelector) {}

  readonly url = computed(() => this.resolvedConfig()['url'] as unknown as string);
  readonly text = computed(() => this.resolvedConfig()['text'] as unknown as string);
  readonly target = computed(
    () => this.resolvedConfig()['target'] as unknown as ExternalLinkButtonTarget,
  );
  readonly type = computed(
    () => this.resolvedConfig()['type'] as unknown as ExternalLinkButtonType,
  );
  readonly icon = computed(
    () => this.resolvedConfig()['icon'] as unknown as IContentBuilderFieldImage,
  );
  readonly onlyOnShop = computed(
    () => this.resolvedConfig()['only_on_shop'] as unknown as Array<{ id: string }>,
  );

  get displayThisLink(): boolean {
    const onlyOnShop = this.onlyOnShop();
    if (!onlyOnShop?.length) {
      return true;
    }

    const activeOrder = this.orderSelector.active;
    return !!activeOrder && onlyOnShop.some(shop => shop.id === activeOrder.shop?.id);
  }

  click(): void {
    const url = this.url();
    if (url) {
      window.open(url, this.target());
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(UserFeedbackLinkBlockComponent, { 'keyAliases': {} });
